module.exports = __webpack_public_path__ + "static/media/address.bd7cc971.svg";